(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["asthros-pdp-monte-look"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('asthros-pdp-monte-look')) {
    class AsthrosPdpMonteLook extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready === 'true') return;
        this.dataset.ready = 'true';

        this.payload = this.readPayload();
        this.cards = this.payload.cards || [];
        this.looksByColor = this.payload.looksByColor || {};
        this.mainCardTemplate = this.cards.find(function(card) {
          return card && card.type === 'main';
        }) || this.cards[0] || null;
        this.cardStates = new Map();
        this.cardEls = Array.from(this.querySelectorAll('[data-ml-card]'));
        this.abortController = new AbortController();
        this.signal = this.abortController.signal;
        this.busy = false;

        this.bindPdpVariant();
        this.bindAzpVariantChange();
        this.bindHistoryVariantChange();
        if (!this.cards.length) return;

        this.initCards();
        var initialVariant = this.currentPdpVariant();
        if (initialVariant) {
          this.updateMainVariant(initialVariant);
        } else {
          this.refreshAll();
        }
      }

      disconnectedCallback() {
        if (this.abortController) this.abortController.abort();
      }

      readPayload() {
        var script = this.querySelector('[data-monte-look-payload]');
        if (!script) return { settings: {}, cards: [] };

        try {
          return JSON.parse(script.textContent);
        } catch (error) {
          console.warn('[Asthros Monte Look] JSON invalido da section.', error);
          return { settings: {}, cards: [] };
        }
      }

      initCards() {
        var self = this;

        this.cardStates = new Map();
        this.cardEls = Array.from(this.querySelectorAll('[data-ml-card]'));

        this.cards.forEach(function(card) {
          card.colorOption = self.findOption(card, 'color');
          card.sizeOption = self.findOption(card, 'size');
          card.variants = card.variants || [];
          card.options = card.options || [];

          var state = {
            card: card,
            included: card.type === 'main',
            selectedColor: null,
            selectedSize: null,
            selectedVariant: null,
            disabled: false,
            invalid: false
          };

          if (card.type === 'main') {
            state.selectedVariant = self.variantById(card, card.selectedVariantId) || self.firstAvailableVariant(card) || card.variants[0] || null;
            self.syncSelectionsFromVariant(state);
          } else if (card.pinned) {
            self.preparePinnedComplementState(state, false);
          } else {
            self.prepareComplementState(state);
          }

          self.cardStates.set(String(card.index), state);
          self.bindCardControls(state);
          self.applyProductCardCompatibility(state);
        });
      }

      bindCardControls(state) {
        var el = this.cardEl(state.card.index);
        if (!el || state.card.type === 'main') return;

        var checkbox = el.querySelector('[data-ml-include]');
        if (checkbox) {
          checkbox.addEventListener('change', function() {
            state.included = checkbox.checked && !state.disabled;
            state.invalid = false;
            this.refreshAll();
          }.bind(this), { signal: this.signal });
        }

        var toggle = el.querySelector('[data-ml-toggle]');
        if (toggle) {
          toggle.addEventListener('click', function(event) {
            event.preventDefault();
            if (state.disabled) return;
            state.included = !state.included;
            state.invalid = false;
            this.refreshAll();
          }.bind(this), { signal: this.signal });
        }
      }

      bindAzpVariantChange() {
        document.addEventListener('azp:variant:change', function(event) {
          var detail = event.detail || {};
          var variantId = String(detail.variantId || '');
          var variant = detail.variant || null;
          if (!variantId) return;
          this.handleMainVariantChange(variant || this.mainCardVariantById(variantId));
        }.bind(this), { signal: this.signal });
      }

      variantColorKey(variant) {
        return this.normalize(this.variantColorValue(variant));
      }

      variantColorValue(variant) {
        var index = Number(this.dataset.colorOptionIndex || -1);
        if (!variant || index < 0) return '';
        if (variant.options && variant.options.length) return variant.options[index] || '';
        return variant['option' + (index + 1)] || '';
      }

      currentColorKey() {
        return this.normalize(this.dataset.currentColor || this.dataset.currentColorKey || '');
      }

      mainCardVariantById(variantId) {
        var mainCard = this.cards && this.cards[0];
        if (!mainCard) return null;
        return this.variantById(mainCard, variantId);
      }

      handleMainVariantChange(themeVariant) {
        if (!themeVariant || !themeVariant.id || this.busy) return;

        var variantId = String(themeVariant.id);
        if (variantId === String(this.dataset.currentVariantId || '')) return;

        var nextColorKey = this.variantColorKey(themeVariant);
        var currentColorKey = this.currentColorKey();
        var mainVariant = this.mainCardVariantById(variantId) || themeVariant;
        this.setBrowserVariant(variantId);

        // Regra de negocio: tamanho muda o card principal; cor muda a lista de complementos.
        if (currentColorKey && nextColorKey && currentColorKey === nextColorKey) {
          this.dataset.currentVariantId = variantId;
          this.updateMainVariant(mainVariant);
          return;
        }

        if (this.switchLookForVariant(mainVariant, nextColorKey)) return;

        this.reloadForVariant(variantId);
      }

      switchLookForVariant(themeVariant, colorKey) {
        var hasLookMap = this.looksByColor && Object.keys(this.looksByColor).length;
        if (!hasLookMap || !this.mainCardTemplate || !themeVariant || !themeVariant.id) return false;

        var nextColorKey = colorKey || this.variantColorKey(themeVariant);
        if (!nextColorKey) return false;

        var look = this.looksByColor[nextColorKey];
        var mainCard = this.cloneCard(this.mainCardTemplate);
        mainCard.selectedVariantId = themeVariant.id;
        var nextCards = [mainCard];
        var hasComplements = Boolean(look && Array.isArray(look.cards) && look.cards.length);

        if (hasComplements) {
          look.cards.forEach(function(card, index) {
            var nextCard = this.cloneCard(card);
            nextCard.index = index + 1;
            nextCard.type = 'complement';
            nextCards.push(nextCard);
          }.bind(this));
        }

        this.dataset.currentVariantId = String(themeVariant.id);
        this.dataset.currentColor = this.variantColorValue(themeVariant) || (look && look.color) || '';
        this.dataset.currentColorKey = nextColorKey;
        this.cards = nextCards;
        this.rebuildCardsMarkup();
        this.initCards();
        this.updateMainVariant(themeVariant);
        this.setSectionVisible(hasComplements);
        return true;
      }

      cloneCard(card) {
        return card ? JSON.parse(JSON.stringify(card)) : null;
      }

      setSectionVisible(visible) {
        var section = this.closest('.asthros-ml');
        if (section) section.hidden = !visible;
      }

      rebuildCardsMarkup() {
        var cardsRoot = this.querySelector('[data-ml-cards]');
        if (!cardsRoot) return;

        var mainEl = cardsRoot.querySelector('[data-card-index="0"]');
        if (mainEl) mainEl.remove();

        cardsRoot.innerHTML = '';
        if (mainEl) cardsRoot.appendChild(mainEl);

        this.cards.slice(1).forEach(function(card) {
          cardsRoot.appendChild(this.createMathNode(this.separatorText(), false));
          cardsRoot.appendChild(this.createComplementCard(card));
        }.bind(this));

        cardsRoot.appendChild(this.createMathNode('=', true));
        this.updateCardsCountClass(cardsRoot);
        this.cardEls = Array.from(this.querySelectorAll('[data-ml-card]'));
      }

      updateCardsCountClass(cardsRoot) {
        var root = cardsRoot || this.querySelector('[data-ml-cards]');
        if (!root) return;

        root.classList.remove(
          'asthros-ml__cards--count-1',
          'asthros-ml__cards--count-2',
          'asthros-ml__cards--count-3',
          'asthros-ml__cards--count-4'
        );
        root.classList.add('asthros-ml__cards--count-' + Math.min(Math.max(this.cards.length, 1), 4));
      }

      createMathNode(text, equals) {
        var node = document.createElement('span');
        node.className = 'asthros-ml__math' + (equals ? ' asthros-ml__math--equals' : '');
        node.setAttribute('aria-hidden', 'true');
        node.textContent = text;
        return node;
      }

      createComplementCard(card) {
        var sectionId = (this.payload.settings && this.payload.settings.sectionId) || this.dataset.sectionId || 'monte-look';
        var article = document.createElement('article');
        article.className = 'asthros-ml-card';
        article.dataset.mlCard = '';
        article.dataset.cardIndex = String(card.index);
        article.dataset.cardType = 'complement';

        var check = document.createElement('label');
        check.className = 'asthros-ml-card__check';
        check.hidden = true;
        var input = document.createElement('input');
        input.className = 'asthros-ml-card__checkbox';
        input.type = 'checkbox';
        input.checked = false;
        input.dataset.mlInclude = '';
        input.setAttribute('aria-label', 'Incluir ' + (card.title || 'produto') + ' no look');
        var checkUi = document.createElement('span');
        checkUi.className = 'asthros-ml-card__check-ui';
        check.appendChild(input);
        check.appendChild(checkUi);

        var media = document.createElement('a');
        media.className = 'asthros-ml-card__media';
        media.href = card.url || '#';
        media.setAttribute('aria-label', card.title || 'Produto do look');
        if (card.featuredImage) {
          var img = document.createElement('img');
          img.src = card.featuredImage;
          img.alt = card.title || '';
          img.width = 720;
          img.height = 900;
          img.loading = 'lazy';
          img.dataset.mlCardImg = '';
          media.appendChild(img);
        } else {
          var placeholder = document.createElement('span');
          placeholder.className = 'asthros-ml-card__placeholder';
          placeholder.dataset.mlCardImg = '';
          media.appendChild(placeholder);
        }

        var body = document.createElement('div');
        body.className = 'asthros-ml-card__body';

        var role = document.createElement('span');
        role.className = 'asthros-ml-card__role';
        role.textContent = 'Combine com';

        var title = document.createElement('h3');
        title.className = 'asthros-ml-card__name';
        title.textContent = card.title || 'Produto do look';

        var variantLabel = document.createElement('p');
        variantLabel.className = 'asthros-ml-card__variant';
        variantLabel.dataset.mlVariantLabel = '';

        var price = document.createElement('p');
        price.className = 'asthros-ml-card__price';
        price.dataset.mlCardPrice = '';

        var controls = document.createElement('div');
        controls.className = 'asthros-ml-card__controls';
        controls.dataset.mlControls = '';

        var colorControl = document.createElement('div');
        colorControl.className = 'asthros-ml-card__option';
        colorControl.dataset.mlColorControl = '';
        colorControl.hidden = true;
        var colorLabel = document.createElement('p');
        colorLabel.className = 'asthros-ml-card__option-label';
        colorLabel.id = 'AsthrosMonteLook-' + sectionId + '-card-' + card.index + '-color';
        colorLabel.textContent = 'Cor';
        var colorOptions = document.createElement('div');
        colorOptions.className = 'asthros-ml-card__pills';
        colorOptions.setAttribute('role', 'radiogroup');
        colorOptions.setAttribute('aria-labelledby', colorLabel.id);
        colorOptions.dataset.mlColorOptions = '';
        colorControl.appendChild(colorLabel);
        colorControl.appendChild(colorOptions);

        var sizeControl = document.createElement('div');
        sizeControl.className = 'asthros-ml-card__option';
        sizeControl.dataset.mlSizeControl = '';
        sizeControl.hidden = true;
        var sizeLabel = document.createElement('p');
        sizeLabel.className = 'asthros-ml-card__option-label';
        sizeLabel.id = 'AsthrosMonteLook-' + sectionId + '-card-' + card.index + '-size';
        sizeLabel.textContent = 'Tamanho';
        var sizeOptions = document.createElement('div');
        sizeOptions.className = 'asthros-ml-card__pills';
        sizeOptions.setAttribute('role', 'radiogroup');
        sizeOptions.setAttribute('aria-labelledby', sizeLabel.id);
        sizeOptions.dataset.mlSizeOptions = '';
        sizeControl.appendChild(sizeLabel);
        sizeControl.appendChild(sizeOptions);

        controls.appendChild(colorControl);
        controls.appendChild(sizeControl);

        var toggle = document.createElement('button');
        toggle.className = 'asthros-ml-card__toggle';
        toggle.type = 'button';
        toggle.dataset.mlToggle = '';
        toggle.setAttribute('aria-pressed', 'false');
        toggle.textContent = 'Adicionar peça';

        var status = document.createElement('p');
        status.className = 'asthros-ml-card__status';
        status.dataset.mlCardStatus = '';
        status.setAttribute('aria-live', 'polite');

        body.appendChild(role);
        body.appendChild(title);
        body.appendChild(variantLabel);
        body.appendChild(price);
        body.appendChild(controls);
        body.appendChild(toggle);
        body.appendChild(status);

        article.appendChild(check);
        article.appendChild(media);
        article.appendChild(body);
        return article;
      }

      setBrowserVariant(variantId) {
        if (!variantId || !window.history || typeof window.history.replaceState !== 'function') return;

        try {
          var url = new URL(window.location.href);
          if (url.searchParams.get('variant') === String(variantId)) return;
          url.searchParams.set('variant', variantId);
          window.history.replaceState({ path: url.toString() }, '', url.toString());
        } catch (error) {
          // Sem acao: a troca do look nao deve falhar por historico do navegador.
        }
      }

      schedulePdpVariantUpdate(preferUrl) {
        [0, 80, 180].forEach(function(delay) {
          window.setTimeout(function() {
            this.handleMainVariantChange(this.currentPdpVariant(preferUrl));
          }.bind(this), delay);
        }.bind(this));
      }

      bindHistoryVariantChange() {
        if (!window.__asthrosMonteLookHistoryPatched) {
          ['pushState', 'replaceState'].forEach(function(method) {
            var original = window.history[method];
            if (typeof original !== 'function') return;

            window.history[method] = function() {
              var result = original.apply(this, arguments);
              window.dispatchEvent(new Event('asthros:history-change'));
              return result;
            };
          });
          window.__asthrosMonteLookHistoryPatched = true;
        }

        window.addEventListener('asthros:history-change', function() {
          this.schedulePdpVariantUpdate(true);
        }.bind(this), { signal: this.signal });

        window.addEventListener('popstate', function() {
          this.schedulePdpVariantUpdate(true);
        }.bind(this), { signal: this.signal });
      }

      reloadForVariant(variantId) {
        var sectionId = this.dataset.sectionId;
        if (!sectionId || this.busy) return;

        this.busy = true;
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variantId);
        url.searchParams.set('section_id', sectionId);

        fetch(url.toString(), { credentials: 'same-origin' })
          .then(function(response) {
            if (!response.ok) throw new Error('monte look section render failed');
            return response.text();
          })
          .then(function(html) {
            var temp = document.createElement('div');
            temp.innerHTML = html.trim();
            var nextSection = temp.querySelector('#AsthrosMonteLook-' + sectionId) || temp.firstElementChild;
            var currentSection = this.closest('.asthros-ml') || this;

            if (!nextSection) {
              currentSection.hidden = true;
              return;
            }

            currentSection.replaceWith(nextSection);
          }.bind(this))
          .catch(function(error) {
            console.warn('[Asthros Monte Look] Nao foi possivel atualizar o look da cor.', error);
          })
          .finally(function() {
            this.busy = false;
          }.bind(this));
      }

      preparePinnedComplementState(state, preserveChoice) {
        var card = state.card;
        var previousChoice = Boolean(state.included);
        state.selectedVariant = this.variantById(card, card.selectedVariantId) || card.variants[0] || null;
        state.disabled = !(state.selectedVariant && state.selectedVariant.available);
        state.invalid = false;
        state.included = state.disabled ? false : (preserveChoice ? previousChoice : false);
      }

      prepareComplementState(state) {
        var card = state.card;

        if (card.colorOption) {
          state.selectedColor = this.firstAvailableValue(card, card.colorOption, {});
        }

        if (card.sizeOption) {
          state.selectedSize = this.firstAvailableValue(card, card.sizeOption, {
            color: state.selectedColor
          });
        }

        state.selectedVariant = this.resolveComplementVariant(state);

        if (!state.selectedVariant || !state.selectedVariant.available) {
          state.disabled = !this.hasAvailableVariant(card, {
            color: state.selectedColor
          });
          if (state.disabled) state.included = false;
        } else {
          state.disabled = false;
          state.included = Boolean(state.included);
        }
      }

      bindPdpVariant() {
        var productId = String(this.dataset.currentProductId || '');
        this.pdpVariants = [];

        this.pdpSection = Array.prototype.find.call(
          document.querySelectorAll('[data-section-type="product"][id^="ProductSection-"]'),
          function(section) {
            var handle = section.getAttribute('data-handle') || '';
            var productJson = section.querySelector('script[id^="ProductJson-"]');
            if (!productJson) return true;
            try {
              var data = JSON.parse(productJson.textContent);
              return String(data.id || '') === productId;
            } catch (error) {
              return Boolean(handle);
            }
          }
        );

        if (!this.pdpSection) return;

        this.pdpSectionId = this.pdpSection.id.replace(/^ProductSection-/, '');
        this.pdpMasterSelect = document.getElementById('ProductSelect-' + this.pdpSectionId) || this.pdpSection.querySelector('select[name="id"]');
        this.pdpVariantRoot = this.pdpMasterSelect
          ? (this.pdpMasterSelect.closest('.azua-product-variants, .product-button-variant, form') || this.pdpSection)
          : this.pdpSection;

        var productJson = this.pdpSection.querySelector('script[id^="ProductJson-"]');
        if (productJson && productJson.textContent) {
          try {
            var productData = JSON.parse(productJson.textContent);
            this.pdpVariants = productData.variants || [];
          } catch (error) {
            this.pdpVariants = [];
          }
        }

        if (window.jQuery) {
          var namespace = '.asthrosMonteLook' + String(this.dataset.sectionId || '').replace(/[^A-Za-z0-9]/g, '');
          var eventName = 'variantChange' + namespace;

          window.jQuery(this.pdpSection)
            .off(eventName)
            .on(eventName, function(event) {
              this.handleMainVariantChange(event.variant || this.currentPdpVariant());
            }.bind(this));

          this.signal.addEventListener('abort', function() {
            window.jQuery(this.pdpSection).off(eventName);
          }.bind(this), { once: true });
        }

        document.addEventListener('change', function(event) {
          if (!this.isPdpVariantTarget(event.target, false)) return;
          var variant = this.variantFromPdpTarget(event.target);
          if (variant) {
            this.handleMainVariantChange(variant);
            return;
          }
          this.schedulePdpVariantUpdate(true);
        }.bind(this), { signal: this.signal, capture: true });

        document.addEventListener('click', function(event) {
          if (!this.isPdpVariantTarget(event.target, true)) return;
          var variant = this.variantFromPdpTarget(event.target);
          if (variant) {
            this.handleMainVariantChange(variant);
            return;
          }
          this.schedulePdpVariantUpdate(true);
        }.bind(this), { signal: this.signal, capture: true });
      }

      isPdpVariantTarget(target, includeLabels) {
        if (!target || !this.pdpSection) return false;
        var node = target.nodeType === 1 ? target : target.parentElement;
        if (!node || !this.pdpSection.contains(node)) return false;

        if (this.pdpControlFromTarget(node)) {
          return true;
        }

        return Boolean(includeLabels && node.closest('label[for^="ProductSelect-option-"], .swatch-element, [class*="st-color-"]'));
      }

      pdpOptionSelector() {
        return this.pdpSectionId
          ? '.single-option-selector-' + this.cssEscape(this.pdpSectionId)
          : '[class*="single-option-selector-"]';
      }

      pdpControlFromTarget(target) {
        if (!target || !this.pdpSection) return null;
        var node = target.nodeType === 1 ? target : target.parentElement;
        if (!node || !this.pdpSection.contains(node)) return null;

        var optionSelector = this.pdpOptionSelector();
        if (node.matches('select[name="id"], input[name="id"], select[id^="ProductSelect-"], input[id^="ProductSelect-"], ' + optionSelector)) {
          return node;
        }

        var label = node.closest('label[for]');
        if (label && this.pdpSection.contains(label)) {
          var control = document.getElementById(label.getAttribute('for'));
          if (control && this.pdpSection.contains(control) && control.matches(optionSelector)) return control;
        }

        return null;
      }

      variantFromPdpTarget(target) {
        var control = this.pdpControlFromTarget(target);
        var variants = this.pdpVariants && this.pdpVariants.length ? this.pdpVariants : ((this.cards[0] && this.cards[0].variants) || []);
        if (!control || !variants.length) return null;

        if (control.matches('select[name="id"], input[name="id"], select[id^="ProductSelect-"]') && control.value) {
          var variantByMaster = this.variantById({ variants: variants }, control.value);
          if (variantByMaster) return variantByMaster;
        }

        var key = control.dataset.index;
        if (!key || !control.value) return null;

        var selected = this.selectedPdpOptions();
        selected[key] = control.value;
        return this.variantFromSelectedOptions(variants, selected);
      }

      currentPdpVariant(preferUrl) {
        var mainState = this.cardStates.get('0');
        var variants = mainState && mainState.card ? mainState.card.variants : (this.pdpVariants || []);
        if (!variants.length) return null;

        if (preferUrl) {
          var variantFromUrl = this.variantFromUrl(variants);
          if (variantFromUrl) return variantFromUrl;
        }

        var selected = {};
        if (this.pdpSection) {
          selected = this.selectedPdpOptions();
        }

        var variantFromOptions = this.variantFromSelectedOptions(variants, selected);
        if (variantFromOptions) return variantFromOptions;

        var fallbackVariantFromUrl = this.variantFromUrl(variants);
        if (fallbackVariantFromUrl) return fallbackVariantFromUrl;

        var variantInput = this.pdpMasterSelect || (this.pdpSection ? this.pdpSection.querySelector('select[name="id"], input[name="id"]') : null);
        if (variantInput && variantInput.value) {
          return this.variantById({ variants: variants }, variantInput.value);
        }

        return null;
      }

      selectedPdpOptions() {
        var selected = {};
        var root = this.pdpVariantRoot || this.pdpSection;
        if (!root) return selected;

        root.querySelectorAll(this.pdpOptionSelector()).forEach(function(input) {
          var key = input.dataset.index;
          if (!key) return;
          if (input.type === 'radio' || input.type === 'checkbox') {
            if (input.checked) selected[key] = input.value;
            return;
          }
          selected[key] = input.value;
        });

        return selected;
      }

      variantFromSelectedOptions(variants, selected) {
        var keys = Object.keys(selected || {});
        if (!keys.length) return null;

        return variants.find(function(variant) {
          return keys.every(function(key) {
            return String(variant[key]) === String(selected[key]);
          });
        }) || null;
      }

      variantFromUrl(variants) {
        var variantId = '';
        try {
          variantId = new URL(window.location.href).searchParams.get('variant') || '';
        } catch (error) {
          variantId = '';
        }
        return variantId ? this.variantById({ variants: variants }, variantId) : null;
      }

      updateMainVariant(themeVariant) {
        var state = this.cardStates.get('0');
        if (!state || !themeVariant) return;

        var variant = this.variantById(state.card, themeVariant.id) || themeVariant;
        state.selectedVariant = variant;
        state.disabled = !(variant && variant.available);
        state.included = true;
        state.invalid = false;
        this.syncSelectionsFromVariant(state);
        this.refreshAll();
      }

      syncSelectionsFromVariant(state) {
        var card = state.card;
        if (!state.selectedVariant) return;
        if (card.colorOption) state.selectedColor = this.optionValue(state.selectedVariant, card.colorOption);
        if (card.sizeOption) state.selectedSize = this.optionValue(state.selectedVariant, card.sizeOption);
      }

      refreshAll() {
        var self = this;
        this.cards.forEach(function(card) {
          var state = self.cardStates.get(String(card.index));
          if (!state) return;
          if (card.type !== 'main') {
            if (card.pinned) {
              self.preparePinnedComplementState(state, true);
            } else {
              state.selectedVariant = self.resolveComplementVariant(state);
              state.disabled = !self.hasAnyUsableVariant(state);
              if (state.disabled) state.included = false;
            }
          }
          self.renderCard(state);
        });
        this.renderSummary();
      }

      renderCard(state) {
        var card = state.card;
        var el = this.cardEl(card.index);
        if (!el) return;

        var variant = state.selectedVariant;
        var imageEl = el.querySelector('[data-ml-card-img]');
        var priceEl = el.querySelector('[data-ml-card-price]');
        var variantLabel = el.querySelector('[data-ml-variant-label]');
        var status = el.querySelector('[data-ml-card-status]');
        var checkbox = el.querySelector('[data-ml-include]');
        var toggle = el.querySelector('[data-ml-toggle]');

        el.classList.toggle('is-disabled', Boolean(state.disabled));
        el.classList.toggle('is-invalid', Boolean(state.invalid));

        if (imageEl && imageEl.tagName === 'IMG') {
          var image = variant && variant.image ? variant.image : card.featuredImage;
          if (image && imageEl.getAttribute('src') !== image) imageEl.setAttribute('src', image);
        }

        if (priceEl) {
          priceEl.textContent = variant && variant.price != null ? this.money(variant.price) : 'Esgotado';
        }

        if (variantLabel) {
          variantLabel.textContent = this.variantLabel(state);
        }

        if (checkbox) {
          checkbox.checked = Boolean(state.included);
          checkbox.disabled = Boolean(state.disabled);
        }

        if (toggle) {
          toggle.disabled = Boolean(state.disabled);
          toggle.setAttribute('aria-pressed', state.included && !state.disabled ? 'true' : 'false');
          toggle.textContent = state.disabled ? 'Esgotado' : (state.included ? 'Remover' : 'Adicionar peça');
        }

        this.applyProductCardCompatibility(state);

        if (status) {
          status.textContent = state.disabled ? 'Esgotado' : (state.invalid ? 'Escolha uma opcao para continuar.' : '');
        }

        this.renderOptionControls(state);
      }

      renderOptionControls(state) {
        var card = state.card;
        var el = this.cardEl(card.index);
        if (!el) return;

        var colorControl = el.querySelector('[data-ml-color-control]');
        var colorOptions = el.querySelector('[data-ml-color-options]');
        var sizeControl = el.querySelector('[data-ml-size-control]');
        var sizeOptions = el.querySelector('[data-ml-size-options]');

        if (card.pinned) {
          var controls = el.querySelector('[data-ml-controls]');
          if (controls) controls.hidden = true;
          return;
        }

        var showColor = Boolean(card.colorOption) && card.type !== 'main';
        var controlsRoot = el.querySelector('[data-ml-controls]');
        if (controlsRoot) controlsRoot.hidden = (state.disabled && card.type !== 'main') || (!showColor && !card.sizeOption);

        if (colorControl && colorOptions) {
          colorControl.hidden = !showColor;
          if (showColor) this.renderPills(state, card.colorOption, colorOptions, 'color');
        }

        if (sizeControl && sizeOptions) {
          sizeControl.hidden = !card.sizeOption;
          if (card.sizeOption) this.renderPills(state, card.sizeOption, sizeOptions, 'size');
        }
      }

      renderPills(state, option, container, kind) {
        var self = this;
        var values = this.optionValues(state.card, option);
        var current = kind === 'color' ? state.selectedColor : state.selectedSize;

        container.innerHTML = '';
        values.forEach(function(value) {
          var button = document.createElement('button');
          var isColor = kind === 'color';
          var available = self.valueIsAvailable(state, option, value, kind);
          var selected = String(current || '') === String(value);
          var variantForValue = self.variantForOptionValue(state, option, value, kind);

          button.type = 'button';
          button.className = (isColor ? 'asthros-ml-swatch js-swatch-card-item' : 'asthros-ml-pill js-card-size-item');
          button.dataset.optionIndex = String(Number(option.position) - 1);
          button.dataset.value = value;
          if (variantForValue && variantForValue.id) button.dataset.id = variantForValue.id;
          if (variantForValue && variantForValue.image) button.dataset.image = variantForValue.image;
          if (variantForValue && variantForValue.price != null) button.dataset.price = variantForValue.price;
          if (variantForValue && variantForValue.id) button.dataset.url = self.variantUrl(state.card, variantForValue);
          if (variantForValue) button.dataset.available = variantForValue.available ? 'true' : 'false';
          if (selected) button.classList.add('active');
          if (!available) button.classList.add('is-unavailable');
          if (isColor) {
            button.style.setProperty('--ml-swatch-color', self.swatchColor(value));
            button.title = value;
            button.setAttribute('aria-label', 'Cor ' + value);
          } else {
            button.textContent = value;
          }
          button.setAttribute('role', 'radio');
          button.setAttribute('aria-checked', selected ? 'true' : 'false');
          button.setAttribute('aria-pressed', selected ? 'true' : 'false');
          button.disabled = !available;
          button.setAttribute('aria-disabled', available ? 'false' : 'true');

          button.addEventListener('click', function(event) {
            event.preventDefault();
            event.stopPropagation();
            if (!available) return;
            if (kind === 'color') {
              state.selectedColor = value;
              if (state.card.sizeOption && !self.valueIsAvailable(state, state.card.sizeOption, state.selectedSize, 'size')) {
                state.selectedSize = self.firstAvailableValue(state.card, state.card.sizeOption, { color: state.selectedColor });
              }
            } else {
              state.selectedSize = value;
            }
            state.invalid = false;

            if (state.card.type === 'main') {
              var mainVariant = self.resolveSelectedVariant(state);
              if (mainVariant) {
                self.handleMainVariantChange(mainVariant);
                return;
              }
            }

            self.refreshAll();
          }, { signal: self.signal });

          container.appendChild(button);
        });
      }

      swatchColor(value) {
        var key = this.swatchKey(value);
        var colors = {
          'preto': '#0a0a0a',
          'preta': '#0a0a0a',
          'black': '#0a0a0a',
          'branco': '#f2f2f2',
          'branca': '#f2f2f2',
          'white': '#f2f2f2',
          'bege': '#d4c09a',
          'beige': '#d4c09a',
          'azul-marinho': '#22304a',
          'navy': '#22304a',
          'marinho': '#22304a',
          'azul': '#1d4f91',
          'blue': '#1d4f91',
          'cinza': '#777777',
          'gray': '#777777',
          'grey': '#777777',
          'verde': '#596643',
          'green': '#596643',
          'marrom': '#5a4033',
          'brown': '#5a4033',
          'vermelho': '#9f2e2e',
          'red': '#9f2e2e',
          'amarelo': '#d6b447',
          'yellow': '#d6b447',
          'off-white': '#eee8dc',
          'offwhite': '#eee8dc'
        };

        return colors[key] || '#777777';
      }

      swatchKey(value) {
        var text = String(value || '').toLowerCase();
        if (text.normalize) {
          text = text.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
        }
        return text.replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
      }

      applyProductCardCompatibility(state) {
        var el = this.cardEl(state.card.index);
        if (!el) return;

        el.classList.remove('product-card', 'js-product-card');
        if (state.selectedVariant && state.selectedVariant.price != null) {
          el.dataset.price = state.selectedVariant.price;
        }

        var media = el.querySelector('.asthros-ml-card__media');
        if (media) media.classList.remove('product-card__image', 'image-content__image-wrapper');

        var image = el.querySelector('img[data-ml-card-img]');
        if (image) image.classList.remove('first-image', 'scale-in');

        var name = el.querySelector('.asthros-ml-card__name');
        if (name) name.classList.remove('product-card__name');

        var price = el.querySelector('[data-ml-card-price]');
        if (price) price.classList.remove('product-card__price');

        var gridCart = el.querySelector('.js-grid-cart');
        if (!gridCart) {
          gridCart = document.createElement('span');
          gridCart.className = 'js-grid-cart asthros-ml-card__compat-cart';
          gridCart.hidden = true;
          el.appendChild(gridCart);
        }
        if (state.selectedVariant && state.selectedVariant.id) {
          gridCart.dataset.id = state.selectedVariant.id;
          gridCart.setAttribute('data-id', state.selectedVariant.id);
        }

        var variantsScript = el.querySelector('.js-card-variants-json');
        if (!variantsScript) {
          variantsScript = document.createElement('script');
          variantsScript.type = 'application/json';
          variantsScript.className = 'js-card-variants-json';
          el.appendChild(variantsScript);
        }

        variantsScript.textContent = JSON.stringify((state.card.variants || []).map(function(variant) {
          return {
            id: variant.id,
            available: variant.available,
            url: this.variantUrl(state.card, variant),
            image: variant.image || state.card.featuredImage || null,
            options: variant.options || [variant.option1, variant.option2, variant.option3],
            price: variant.price
          };
        }.bind(this)));

        if (window.jQuery) {
          window.jQuery(variantsScript).removeData('variants');
        }
      }

      variantForOptionValue(state, option, value, kind) {
        var card = state.card;
        var matches = (card.variants || []).filter(function(variant) {
          if (!this.optionValueMatches(variant, option, value)) return false;
          if (kind === 'size' && card.colorOption && state.selectedColor && !this.optionValueMatches(variant, card.colorOption, state.selectedColor)) return false;
          if (kind === 'color' && card.sizeOption && state.selectedSize && !this.optionValueMatches(variant, card.sizeOption, state.selectedSize)) return false;
          return true;
        }.bind(this));

        return matches.find(function(variant) { return variant.available; }) || matches[0] || null;
      }

      variantUrl(card, variant) {
        var baseUrl = card.url || window.location.pathname;
        try {
          var url = new URL(baseUrl, window.location.origin);
          if (variant && variant.id) url.searchParams.set('variant', variant.id);
          return url.pathname + url.search + url.hash;
        } catch (error) {
          return baseUrl;
        }
      }

      optionValues(card, option) {
        var values = [];
        var keys = [];

        (card.variants || []).forEach(function(variant) {
          var value = this.optionValue(variant, option);
          var key = this.normalize(value);
          if (!key || keys.indexOf(key) > -1) return;
          keys.push(key);
          values.push(value);
        }.bind(this));

        return values.length ? values : (option.values || []);
      }

      renderSummary() {
        var includedStates = this.includedStates();
        var validStates = includedStates.filter(function(state) {
          return state.selectedVariant && state.selectedVariant.available;
        });
        var total = validStates.reduce(function(sum, state) {
          return sum + Number(state.selectedVariant.price || 0);
        }, 0);

        var totalEl = this.querySelector('[data-ml-total]');
        var installmentsEl = this.querySelector('[data-ml-installments]');
        var itemsEl = this.querySelector('[data-ml-summary-items], [data-ml-summary-thumbs]');
        var addButton = this.querySelector('[data-ml-add]');

        if (totalEl) totalEl.textContent = this.money(total);
        if (installmentsEl) installmentsEl.textContent = this.installmentText(total);

        if (itemsEl) {
          itemsEl.innerHTML = '';
          validStates.forEach(function(state) {
            var image = state.selectedVariant.image || state.card.featuredImage;
            var item = document.createElement('div');
            var media = image ? document.createElement('img') : document.createElement('span');
            var content = document.createElement('div');
            var title = document.createElement('strong');
            var variant = document.createElement('span');
            var price = document.createElement('strong');
            var variantText = this.variantLabel(state);

            item.className = 'asthros-ml-summary__item';

            media.className = image ? 'asthros-ml-summary__item-image' : 'asthros-ml-summary__item-placeholder';
            if (image) {
              media.src = image;
              media.alt = state.card.title || '';
              media.loading = 'lazy';
            }

            content.className = 'asthros-ml-summary__item-content';

            title.className = 'asthros-ml-summary__item-title';
            title.textContent = state.card.title || 'Produto do look';

            variant.className = 'asthros-ml-summary__item-variant';
            variant.textContent = variantText;
            if (!variantText) variant.hidden = true;

            price.className = 'asthros-ml-summary__item-price';
            price.textContent = this.money(state.selectedVariant.price || 0);

            content.appendChild(title);
            content.appendChild(variant);
            content.appendChild(price);
            item.appendChild(media);
            item.appendChild(content);
            itemsEl.appendChild(item);
          }.bind(this));
        }

        if (addButton) {
          addButton.textContent = this.ctaText(includedStates.length);
          addButton.disabled = this.busy || !includedStates.length || !this.mainIsAddable();
        }
      }

      addToCart() {
        var invalid = this.invalidIncludedStates();
        var button = this.querySelector('[data-ml-add]');

        if (invalid.length) {
          invalid.forEach(function(state) {
            state.invalid = true;
          });
          this.refreshAll();
          this.message('Escolha o tamanho dos itens marcados para adicionar o look.', 'error');
          return;
        }

        var items = this.includedStates().map(function(state) {
          return {
            id: Number(state.selectedVariant.id),
            quantity: 1
          };
        });

        if (!items.length) {
          this.message(this.minimumText(), 'error');
          return;
        }

        if (this.busy) return;

        this.busy = true;
        if (button) button.disabled = true;
        this.message('Adicionando look ao carrinho...', '');

        fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({ items: items })
        })
          .then(function(response) {
            if (!response.ok) return response.json().then(function(error) { throw error; });
            return response.json();
          })
          .then(function() {
            // Regra de negocio: manter o mini-cart Gluck como fonte de verdade.
            if (window.theme && theme.miniCart) {
              if (typeof theme.miniCart.generateCart === 'function') theme.miniCart.generateCart();
              if (typeof theme.miniCart.updateElements === 'function') theme.miniCart.updateElements();
            }
            var drawer = document.querySelector('.js-mini-cart');
            if (drawer) drawer.classList.add('active');
            this.message('Look adicionado ao carrinho.', 'success');
          }.bind(this))
          .catch(function(error) {
            console.warn('[Asthros Monte Look] Falha ao adicionar look.', error);
            this.message('Nao foi possivel adicionar o look. Confira a disponibilidade e tente novamente.', 'error');
          }.bind(this))
          .finally(function() {
            this.busy = false;
            this.refreshAll();
          }.bind(this));
      }

      includedStates() {
        return Array.from(this.cardStates.values()).filter(function(state) {
          return state.included && !state.disabled;
        });
      }

      invalidIncludedStates() {
        return this.includedStates().filter(function(state) {
          return !state.selectedVariant || !state.selectedVariant.available || (state.card.type !== 'main' && state.card.sizeOption && !state.selectedSize);
        });
      }

      mainIsAddable() {
        var state = this.cardStates.get('0');
        return Boolean(state && state.selectedVariant && state.selectedVariant.available);
      }

      message(text, type) {
        var node = this.querySelector('[data-ml-message]');
        if (!node) return;
        node.textContent = text || '';
        node.classList.toggle('is-error', type === 'error');
        node.classList.toggle('is-success', type === 'success');
      }

      ctaText(count) {
        var token = '{' + '{ n }' + '}';
        var template = (this.payload.settings && this.payload.settings.ctaTemplate) || 'Adicionar [n] itens';
        var pattern = new RegExp('\\{\\{\\s*n\\s*\\}\\}', 'g');
        return template.replace(pattern, count).replace(/\[n\]/g, count).replace(token, count);
      }

      minimumText() {
        return (this.payload.settings && this.payload.settings.minimumText) || 'Selecione pelo menos 1 item disponivel.';
      }

      separatorText() {
        return (this.payload.settings && this.payload.settings.separatorText) || '+';
      }

      installmentText(total) {
        var settings = this.payload.settings || {};
        var installments = Math.max(1, Number(settings.installments || 1));
        var rate = Number(settings.interestRate || 0);
        var amount = 0;

        if (!total) return '';

        if (rate === 0) {
          amount = total / installments;
          return 'ate ' + installments + 'x de ' + this.money(amount) + ' s/ juros';
        }

        var monthlyRate = rate / 100;
        var factor = Math.pow(1 + monthlyRate, installments);
        var denominator = factor - 1;
        amount = denominator ? (total * monthlyRate * factor) / denominator : 0;
        return 'ate ' + installments + 'x de ' + this.money(amount) + ' c/ juros';
      }

      money(cents) {
        var value = Number(cents || 0);
        if (window.theme && theme.Currency && typeof theme.Currency.formatMoney === 'function') {
          return theme.Currency.formatMoney(Math.round(value), theme.moneyFormat);
        }

        try {
          return (value / 100).toLocaleString('pt-BR', {
            style: 'currency',
            currency: (this.payload.settings && this.payload.settings.currency) || 'BRL'
          });
        } catch (error) {
          return 'R$ ' + (value / 100).toFixed(2).replace('.', ',');
        }
      }

      variantLabel(state) {
        var variant = state.selectedVariant;
        if (!variant || !variant.title || variant.title === 'Default Title') return '';

        if (state.card.type === 'main') return variant.title;
        if (state.card.pinned) return variant.title;

        var parts = [];
        if (state.selectedColor) parts.push('Cor: ' + state.selectedColor);
        if (state.selectedSize) parts.push('Tamanho: ' + state.selectedSize);
        return parts.length ? parts.join(' · ') : variant.title;
      }

      resolveComplementVariant(state) {
        return this.resolveSelectedVariant(state);
      }

      resolveSelectedVariant(state) {
        var card = state.card;
        var matches = card.variants.filter(function(variant) {
          if (card.colorOption && state.selectedColor && !this.optionValueMatches(variant, card.colorOption, state.selectedColor)) return false;
          if (card.sizeOption && state.selectedSize && !this.optionValueMatches(variant, card.sizeOption, state.selectedSize)) return false;
          if (card.sizeOption && !state.selectedSize) return false;
          return true;
        }.bind(this));

        return matches.find(function(variant) { return variant.available; }) || matches[0] || null;
      }

      hasAnyUsableVariant(state) {
        var card = state.card;
        if (!card.variants.length) return false;
        if (!card.colorOption && !card.sizeOption) return Boolean(card.variants.find(function(variant) { return variant.available; }));

        return Boolean(card.variants.find(function(variant) {
          if (!variant.available) return false;
          if (card.colorOption && state.selectedColor && !this.optionValueMatches(variant, card.colorOption, state.selectedColor)) return false;
          return true;
        }.bind(this)));
      }

      hasAvailableVariant(card, selection) {
        return Boolean(card.variants.find(function(variant) {
          if (!variant.available) return false;
          if (selection.color && card.colorOption && !this.optionValueMatches(variant, card.colorOption, selection.color)) return false;
          if (selection.size && card.sizeOption && !this.optionValueMatches(variant, card.sizeOption, selection.size)) return false;
          return true;
        }.bind(this)));
      }

      valueIsAvailable(state, option, value, kind) {
        return Boolean(state.card.variants.find(function(variant) {
          if (!variant.available) return false;
          if (!this.optionValueMatches(variant, option, value)) return false;
          if (kind === 'size' && state.card.colorOption && state.selectedColor && !this.optionValueMatches(variant, state.card.colorOption, state.selectedColor)) return false;
          return true;
        }.bind(this)));
      }

      firstAvailableValue(card, option, selection) {
        var variant = card.variants.find(function(item) {
          if (!item.available) return false;
          if (selection.color && card.colorOption && !this.optionValueMatches(item, card.colorOption, selection.color)) return false;
          if (selection.size && card.sizeOption && !this.optionValueMatches(item, card.sizeOption, selection.size)) return false;
          return this.optionValue(item, option) != null;
        }.bind(this));

        return variant ? this.optionValue(variant, option) : null;
      }

      firstAvailableVariant(card) {
        return (card.variants || []).find(function(variant) {
          return variant.available;
        });
      }

      variantById(card, id) {
        return (card.variants || []).find(function(variant) {
          return String(variant.id) === String(id);
        });
      }

      findOption(card, type) {
        var matcher = type === 'color' ? this.isColorOption : this.isSizeOption;
        return (card.options || []).find(function(option) {
          return matcher.call(this, option.name);
        }.bind(this)) || null;
      }

      optionValue(variant, option) {
        if (!variant || !option) return null;
        return variant['option' + option.position] != null
          ? variant['option' + option.position]
          : (variant.options || [])[Number(option.position) - 1];
      }

      optionValueMatches(variant, option, value) {
        return this.normalize(this.optionValue(variant, option)) === this.normalize(value);
      }

      isColorOption(name) {
        var normalized = this.normalize(name);
        return ['cor', 'color', 'cores', 'colors'].indexOf(normalized) > -1;
      }

      isSizeOption(name) {
        var normalized = this.normalize(name);
        return ['tamanho', 'tamanhos', 'size', 'sizes', 'tam'].indexOf(normalized) > -1;
      }

      normalize(value) {
        return String(value || '')
          .toLowerCase()
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
          .replace(/[-_]+/g, ' ')
          .trim()
          .replace(/\s+/g, ' ');
      }

      cssEscape(value) {
        if (window.CSS && typeof window.CSS.escape === 'function') {
          return window.CSS.escape(String(value));
        }

        return String(value).replace(/[^a-zA-Z0-9_-]/g, function(character) {
          return '\\' + character;
        });
      }

      cardEl(index) {
        return this.querySelector('[data-ml-card][data-card-index="' + index + '"]');
      }
    }

    customElements.define('asthros-pdp-monte-look', AsthrosPdpMonteLook);
  }

  if (!window.asthrosMonteLookDelegatedClick) {
    document.addEventListener('click', function(event) {
      var button = event.target.closest('asthros-pdp-monte-look [data-ml-add]');
      if (!button) return;
      var root = button.closest('asthros-pdp-monte-look');
      if (root && typeof root.addToCart === 'function') root.addToCart();
    });
    window.asthrosMonteLookDelegatedClick = true;
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper')
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-template"]) return;
  try {
    
    const getpagi = document.querySelector('.AjaxinatePagination');
    if(typeof(getpagi) !== "undefined" && getpagi !== null){
      document.addEventListener("DOMContentLoaded", function() {
        const elem = getpagi.getAttribute('data-pagination');
        var endlessScroll = new Ajaxinate({
          container: '.AjaxinateLoop',
          pagination: '.AjaxinatePagination',
          loadingText: '<span class="loader-line"></span>',
          method: elem == 'scroll' ? 'scroll' : 'click'
        });
      });
    }
    
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
            if (window.SPR && theme.review ) {
              if ($('.shopify-product-reviews-badge').length > 0) {
                return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges();
              };
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 500px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
